function keySort (hash) {
  var keys = []
  var newHash = {}
  for (var k in hash) keys.push(k)
  keys.sort()
  var length = keys.length
  for (var i = 0; i < length; i++) {
    newHash[keys[i]] = hash[keys[i]]
  }
  return newHash
}

export default keySort



// WEBPACK FOOTER //
// ./src/utils/keySort.js